import * as React from 'react';
import {Avatar, TscAvatarSize, TscAvatarSizes} from '@techsmith/tsc-cloud-style-guide';
import UserModel from '../../types/UserModel';
import Constants from '../../globals/Constants';
import StarGlyph from '../../assets/StarGlyph.svg';
import UserService from '../../services/UserService/UserService';

export default ({user, size, isOwner}: AvatarWrapperProps) => {
   const avatarUrl = user && UserService.returnAvatarUrlIfNotDefault(user.avatarUrl);
   const avatarDisplayName = user ? user.isDeleted ? Constants.user.deletedUserAvatarDisplayName : user.name : null;
   const avatarUserId = user ? user.userId : null;
   const avatarSize = size || TscAvatarSize.medium;
   const avatarBackgroundColor = user && user.isDeleted ? Constants.user.deletedUserAvatarBackgroundColor : null;

   return (
      <div className="avatar">
         {isOwner && <div className="avatar-owner"><StarGlyph/></div>}
         <Avatar avatarImageUrl={avatarUrl}
                 userDisplayName={avatarDisplayName}
                 userAltText={null}
                 userID={avatarUserId}
                 size={avatarSize}
                 backgroundColor={avatarBackgroundColor}/>
      </div>
   );
};

export interface AvatarWrapperProps {
   user: UserModel;
   size?: TscAvatarSizes;
   isOwner?: boolean;
}
